
import $ from "jquery";
import Mustache from "mustache";
/* global dataLayer */

"use strict";
export default function () {

	//NodeList forEach polyfill for older browsers
	var productData = null;

	/*
	 1: Do not disable click & collect.
	 0: Disable click and collect but show shop balance.
	-1: Disable click and collect button and show "Myymäläsaatavuus ei käytössä."
	-2: Do not show shop balance and remove click and collect button.
	*/
	var clickAndCollectStatus = 1;
	var clickAndCollect = null;
	var webPriceOnly = false;
	var template = null;

	/**
	 * Initilaise Click and Collect.
	 */
	function init() {
		clickAndCollect = document.querySelector(".product-click-and-collect");

		if (clickAndCollect) {
			template = document.querySelector("#template-click-and-collect")
				.innerHTML;

			var clickAndCollectButton = document.querySelector(
				".click-and-collect-button"
			);
			clickAndCollectStatus = parseInt(
				clickAndCollectButton.getAttribute("data-click-and-collect-status")
			);

			if (clickAndCollectButton.getAttribute("data-web-price-only") === "1") {
				webPriceOnly = true;
			}

			if (clickAndCollectStatus !== 1 && clickAndCollectStatus !== 0) {
				if (clickAndCollectStatus === -1) {
					clickAndCollectButton.disabled = true;
					// document.querySelectorAll('.product-availability').forEach(function (element) {
					//   element.innerHTML = '<h3>Myymäläsaatavuus ei käytössä.</h3><p>Saatavuus ei ole käytössä tälle tuotteelle.</p>';
					// });
				} else if (clickAndCollectStatus === -2) {
					clickAndCollectButton.parentNode.removeChild(clickAndCollectButton);
				}

				var ccTemplate = document.querySelector("#template-click-and-collect");
				ccTemplate.parentNode.removeChild(ccTemplate);
				clickAndCollect.parentNode.removeChild(clickAndCollect);
			} else {
				finalInit();
			}
		}
	}

	init();

	/**
	 * Activate Click and Collect.
	 */
	function finalInit() {
		productData = document.querySelector(".product-article");
		document.body.appendChild(clickAndCollect);
		clickAndCollectEvents();
		productFormEvents();
		sizeChangeEvents();

		//Move delivery-methods modal so that the modal view doesn't break when Click & Collect is visible.
		var deliveryMethodsModal = document.querySelector(
			".modal#delivery-methods"
		);
		if (deliveryMethodsModal) {
			document.body.appendChild(deliveryMethodsModal);
		}
	}

	/**
	 * Scroll position saver & restorer.
	 */
	var scrollPosition = {
		scrollPos: 0,
		reset: function () {
			clickAndCollect.scrollTop = 0;
		},
		save: function () {
			this.scrollPos = clickAndCollect.scrollTop;
		},
		restore: function () {
			clickAndCollect.scrollTop = this.scrollPos;
		}
	};

	var templateData = {
		reservation: {},
		product: {},
		errors: {},
		//  geoLocation : { gotLocation : false },
		stores: [],
		hasStores: false,
		formatPrice: function () {
			return function (text, render) {
				return formatPrice(render(text));
			};
		}
	};

	var shopsFetched = false;
	var shops = [];

	var currentEan = "0";

	/**
	 *  Add, remove and/or toggle class.
	 */
	var elementClassList = {
		add: function (element, className) {
			if (element.className.indexOf(className) === -1) {
				element.className = element.className + " " + className;
			}
		},
		remove: function (element, className) {
			var classes = element.className.split(" ");
			var i = classes.indexOf(className);

			if (i > -1) {
				classes.splice(i, 1);
				element.className = classes.join(" ");
			}
		},
		toggle: function (element, className, toggle) {
			if (typeof toggle !== "undefined") {
				if (toggle) {
					this.add(element, className);
				} else {
					this.remove(element, className);
				}
			} else {
				if (element.className.indexOf(className) === -1) {
					this.add(element, className);
				} else {
					this.remove(element, className);
				}
			}
		}
	};

	/**
	 * Check if element has class.
	 *
	 * @param {Element} element - Element.
	 * @param {string} classname - Class name.
	 *
	 * @returns {boolean} - Has class true/false.
	 */
	var checkElementClass = function (element, classname) {
		return element.className.indexOf(classname) > -1;
	};

	/**
	 * Add Click and Collect event listeners
	 */
	function clickAndCollectEvents() {
		var clickAndCollectClickHandler = function (e) {
			var clickedElement = e.target;

			var toggleView = function () {
				if (checkElementClass(clickAndCollect, "reservation-form-visible")) {
					toggleReservationForm(false);
				} else {
					toggleClickAndCollect(false);
				}
			};
			if (clickedElement.tagName === "BUTTON") {
				if (checkElementClass(clickedElement, "reserve-product-button")) {
					e.preventDefault();
					var reservationData = clickedElement;

					var reservationDataUpdated = updateReservationData(
						reservationData.getAttribute("data-store-id")
					);

					//    console.log('handle reserve product', {
					//      reservationDataUpdated : reservationDataUpdated
					//    });

					if (reservationDataUpdated) {
						updateView(false);
						toggleReservationForm(true);
					}
				} else if (
					checkElementClass(clickedElement, "product-click-and-collect-close")
				) {
					toggleView();
				} else if (
					checkElementClass(
						clickedElement,
						"click-and-collect-reservation-close"
					)
				) {
					toggleReservationForm(false);
				}
			} else if (clickedElement.tagName === "DIV") {
				if (checkElementClass(clickedElement, "close-button-click-area")) {
					toggleView();
				}
			}
		};

		var clickAndCollectFormValidationHelperHandler = function (e) {
			var inputEl = e.target;
			if (inputEl.tagName === "INPUT") {
				if (checkElementClass(inputEl.parentElement, "form-input")) {
					if (!inputEl.checkValidity()) {
						elementClassList.add(inputEl, "invalid");
					} else {
						elementClassList.remove(inputEl, "invalid");
					}
				}
			}
		};

		var clickAndCollectFormHandler = function (e) {
			var form = e.target;
			if (form.tagName === "FORM") {
				if (checkElementClass(form, "click-and-collect-reservation-form")) {
					processReservationForm(e);
				}
			}
		};

		clickAndCollect.addEventListener("click", clickAndCollectClickHandler);

		clickAndCollect.addEventListener(
			"keyup",
			clickAndCollectFormValidationHelperHandler
		);

		clickAndCollect.addEventListener("submit", clickAndCollectFormHandler);
	}

	/**
	 * productFormEvents
	 */
	function productFormEvents() {
		var clickAndCollectButtonHandler = function (e) {
			var productForm = productData.querySelector("form");
			var checkBox = productForm.querySelector("[name=\"ean\"]:checked");

			var checked = false;

			if (checkBox) {
				checked = checkBox.checked;
			}

			if (currentEan === "0" && checked) {
				//getGeoLocation();
				currentEan = checkBox.value;
				updateProductData();
				updateView(true);
			} else {
				updateView(false);
			}

			toggleClickAndCollect(true);
		};

		document
			.querySelector(".click-and-collect-button")
			.addEventListener("click", clickAndCollectButtonHandler);
	}

	/**
	 * Track selected size (add event listeners for property-options #product-size).
	 */
	function sizeChangeEvents() {
		var clickAndCollectItemSizeHandler = function (e) {
			if (e.target.tagName === "LABEL") {
				var checkBox = document.querySelector("#" + e.target.htmlFor);
				if (checkBox.name === "ean") {
					//console.log('EAN:', currentEan);
					//console.log(checkBox.value);

					// if (currentEan !== checkBox.value) {
					currentEan = checkBox.value;

					updateProductData(currentEan);

					toggleReservationForm(false);

					if (
						checkElementClass(document.body, "product-click-and-collect-open")
					) {
						resetTemplate();
					}

					// } else {
					//   console.log('Do not referesh');
					// }
				}
			}
		};

		document
			.querySelector(".property-options #product-size")
			.addEventListener("click", clickAndCollectItemSizeHandler);
	}

	/**
	 * Update product data
	 *
	 * @param {string} ean - Product EAN.
	 */
	function updateProductData(ean) {
		var productForm = productData.querySelector("form");
		var size = productForm.querySelector("[name=\"ean\"]:checked");
		if (typeof ean !== "undefined") {
			size = productForm.querySelector("[value=\"" + ean + "\"]");
		}

		var product = document.querySelector(".product-article");

		var img = product
			.querySelector(
				".product-property.color.box-list a.selected .image-container img"
			)
			.getAttribute("src");

		if (img === "false") {
			img =
				"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGEAAABGCAYAAADcr/otAAAAMUlEQVR4nO3BMQEAAADCoPVPbQ0PoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA+DFqXgABRA1j0gAAAABJRU5ErkJggg==";
		}

		templateData.product = {
			price: parseFloat(
				productData.getAttribute("data-product-price").replace(",", ".")
			),
			color: productData.getAttribute("data-product-color-name").toLowerCase(),
			colorCode: productData.getAttribute("data-product-color"),
			ean: size.value,
			brand: productData.getAttribute("data-product-brand-name"),
			name: productData.getAttribute("data-product-name"),
			sapTitlenumber: productData.getAttribute("data-product-id"),
			size: size.getAttribute("data-name"),
			image: img
		};

		templateData.stores = [];
		templateData.hasStores = false;

		// console.log('templateData', templateData);
	}

	//Geolocation disabled

	// /**
	//  * getGeoLocation
	//  *
	//  */
	// function getGeoLocation() {

	//   var geoSuccess = function (position) {
	//     templateData.geoLocation.enabled = true;
	//     templateData.geoLocation.gotLocation = true;
	//     templateData.geoLocation.lat = position.coords.latitude;
	//     templateData.geoLocation.lon = position.coords.longitude;
	//     updateView(false);
	//   }

	//   var geoError = function (position) {
	//     setError('geoLocation', true);
	//     updateView(false);

	//     window.setTimeout(function () {
	//       delete templateData.errors.geoLocation;
	//       scrollPosition.save();
	//       updateView(false);
	//       scrollPosition.restore();
	//     }, 4000);
	//   }

	//   var geoOptions = {
	//     enableHighAccuracy : true,
	//     maximumAge         : 60000,
	//     timeout            : 5000
	//   };

	//   if (templateData.geoLocation.gotLocation === false) {
	//     navigator.geolocation.getCurrentPosition(geoSuccess, geoError, geoOptions);
	//   }
	// }

	// /**
	//  * orderStoresByLocation
	//  *
	//  * @param {Number} [lat] -
	//  * @param {Number} [lon] -
	//  */
	// function orderStoresByLocation(lat, lon) {
	//   lat = typeof lat !== 'undefined' ? lat : templateData.geoLocation.lat;
	//   lon = typeof lon !== 'undefined' ? lon : templateData.geoLocation.lon;
	//   if (templateData.geoLocation.enabled) {

	//     for (var key in templateData.stores) {
	//       if (templateData.stores.hasOwnProperty(key)) {
	//         var store = templateData.stores[key];
	//         store.distance = Math.round(calculateDistance(lat, lon, Number(store.storeData.lat), Number(store.storeData.long)));
	//       }
	//     }

	//     templateData.stores = templateData.stores.sort(function (a, b) {
	//       return a.distance < b.distance ? -1 : (a.distance > b.distance ? 1 : 0);
	//     });
	//   }
	// }

	// /**
	//  * setError
	//  *
	//  * @param {String} name -
	//  * @param {Boolean} state -
	//  */
	//   function setError(name, state) {
	//     if (name && typeof state !== 'undefined') {
	//       templateData.errors[name] = state;
	//     }
	//   }

	/**
	 * Reset template.
	 */
	function resetTemplate() {
		templateData.errors = {};
		updateView();
	}

	/**
	 * Get store name.
	 *
	 * @param {string} storeId - Store id.
	 *
	 * @returns {string} - Store name.
	 */
	function getStoreName(storeId) {
		var shopName = "";

		for (var i = 0; i < shops.length; i++) {
			var shop = shops[i];
			for (var key of Object.keys(shop)) {
				if (shop[key] === storeId) {
					shopName = shop.name;
				}
			}

			if (shopName !== "") {
				break;
			}
		}

		return shopName;
	}

	/**
	 * Update reservation data.
	 *
	 * @param {String} storeId - Store id.
	 * @param {Number} price - Product price.
	 *
	 * @return {Boolean} - Allow reservation true/false.
	 */
	function updateReservationData(storeId) {
		var isValidReservation = templateData.stores.some(function (store) {
			return store.id === storeId && !store.disableCc; // && store.price === price && !store.disableCc;
		});

		if (isValidReservation) {
			templateData.reservation = {
				items: [
					{
						amount: 1,
						price: templateData.product.price,
						ean: templateData.product.ean,
						name: templateData.product.name,
						color: templateData.product.color,
						size: templateData.product.size,
						image: templateData.product.image,
						sap: templateData.product.sapTitlenumber
					}
				],
				store: getStoreName(storeId),
				storeId: storeId,
				extranet_users_uuid: ""
			};
		}

		return isValidReservation;
	}

	/**
	 * Toggle reservation form view.
	 *
	 * @param {Boolean} showForm - True = show view, false = hide view.
	 */
	function toggleReservationForm(showForm) {
		if (typeof showForm !== "undefined") {
			if (showForm) {
				scrollPosition.save();
				elementClassList.add(clickAndCollect, "reservation-form-visible");
				scrollPosition.reset();
			} else {
				elementClassList.remove(clickAndCollect, "reservation-form-visible");
				scrollPosition.restore();
			}
		}
	}

	/**
	 * Form fields to object.
	 *
	 * @param {Element} form - Form element.
	 * @param {Object} extendObj - Combine with this object.
	 *
	 * @returns {Object} - Form object.
	 */
	function serialiseForm(form, extendObj) {
		var formObject = {};
		var inputs = form.querySelectorAll("input");
		for (var i = 0; i < inputs.length; i++) {
			var input = inputs[i];
			if (input.name) {
				formObject[input.name] = input.value;
			}
		}

		var extend = function (a, b) {
			for (var key of Object.keys(b)) {
				a[key] = b[key];
			}
			return a;
		};

		if (typeof extendObj !== "undefined") {
			return extend(extendObj, formObject);
		} else {
			return formObject;
		}
	}

	/**
	 * Disable or enable form.
	 *
	 * @param {Element} form - Form element.
	 * @param {boolean} mode - Disabled true/false.
	 */
	function formDisable(form, mode) {
		var inputs = form.querySelectorAll("input, button");
		for (var i = 0; i < inputs.length; i++) {
			inputs[i].disabled = mode;
		}
	}

	/**
	 * Process reservation form.
	 *
	 * @param {Object} e - Event.
	 */
	function processReservationForm(e) {
		e.preventDefault();

		var form = document.querySelector(
			".product-click-and-collect .click-and-collect-reservation-form"
		);
		var token = form.querySelector("input[name$=\"token\"]");

		var formErrorMessage =
			"Jotain meni pieleen! Päivitä sivu ja yritä uudelleen.";

		formDisable(form, true);

		clearReservationFormMessages();
		showLoader("Varausta lähetetään...", true);

		if (token.value) {
			//console.log('Send reservation');
			$.ajax({
				data: serialiseForm(form, { items: templateData.reservation.items }),
				dataType: "json",
				method: "POST",
				timeout: 30000,
				url: form.getAttribute("action")
			})
				.done(function (response) {
					if (response && response.state === 1) {
						templateData.reservation.done = true;
						updateView(false);
						toggleReservationForm(true);

						if (dataLayer) {
							dataLayer.push({
								event: "cncOrder",
								store: templateData.reservation.store
							});
						}
					} else if (response && response.reason) {
						addReservationFormMessage(response.reason, true);
					} else {
						addReservationFormMessage(formErrorMessage, true);
					}
				})
				.fail(function (xhr) {
					addReservationFormMessage(formErrorMessage, true);
				})
				.always(function (response) {
					hideLoader(true);

					form.querySelector("input[name$=\"token\"]").value = "";
					//submit.disabled = false;
					formDisable(form, false);
				});
		} else {
			updateFormToken(form);
		}
	}

	/**
	 * Add reservation form message
	 *
	 * @param {String}  msg - Message.
	 * @param {Boolean} isError - Is error true/false.
	 */
	function addReservationFormMessage(msg, isError) {
		clearReservationFormMessages();

		var errorDiv = document.createElement("div");
		errorDiv.className =
			"click-and-collect-info-block" + (isError ? " is-error" : "");
		errorDiv.textContent = msg;
		clickAndCollect
			.querySelector("#click-and-collect-reservation-form-alert-container")
			.appendChild(errorDiv);
	}

	/**
	 * Clear reservation form messages.
	 */
	function clearReservationFormMessages() {
		var errorblock = clickAndCollect.querySelector(
			"#click-and-collect-reservation-form-alert-container .click-and-collect-info-block"
		);
		if (errorblock) {
			errorblock.parentNode.removeChild(errorblock);
		}
	}

	/**
	 * Show loader.
	 *
	 * @param {string} text - Loader text.
	 * @param {boolean} isFormLoader - Is form loader true/false.
	 */
	function showLoader(text, isFormLoader) {
		var loaderSelector;
		if (isFormLoader) {
			loaderSelector = ".click-and-collect-form-loader";
		} else {
			loaderSelector = ".click-and-collect-loader";
		}

		var loader = document.querySelector(loaderSelector);

		if (loader) {
			loader.style.display = "block";

			var loaderText = loader.querySelector("p");

			if (typeof text !== "undefined") {
				if (loaderText) {
					loaderText.innerHTML = text + "<div class=\"loader\"></div>";
				}
			} else {
				if (loaderText) {
					loaderText.innerHTML = "<div class=\"loader\"></div>";
				}
			}
		}
	}

	/**
	 * Hide loader.
	 *
	 * @param {boolean} isFormLoader - Is form loader true/false.
	 */
	function hideLoader(isFormLoader) {
		var loaderSelector;
		if (isFormLoader) {
			loaderSelector = ".click-and-collect-form-loader";
		} else {
			loaderSelector = ".click-and-collect-loader";
		}

		var loader = document.querySelector(loaderSelector);

		if (loader && loader !== null) {
			loader.style.display = "";
		}
	}

	/**
	 * Event listener for tracking clicks outside of Click and Collect view.
	 *
	 * @param {Event} e - Event.
	 */
	var clickAndCollectOutsideClickDetector = function (e) {
		var element = e.target;

		if (
			element.tagName !== "LABEL" &&
			element.tagName !== "A" &&
			element.type !== "button" &&
			element.tagName !== "INPUT"
		) {
			if (checkElementClass(document.body, "product-click-and-collect-open")) {
				toggleClickAndCollect(false);
			}
		}
	};

	/**
	 * Toggle Click and Collect view on/off.
	 *
	 * @param {Boolean} [show] - True = show view, false = hide view.
	 */
	function toggleClickAndCollect(show) {
		show = typeof show !== "undefined" ? show : true;

		elementClassList.toggle(
			document.body,
			"product-click-and-collect-open",
			show
		);

		if (show) {
			resetTemplate();
			document
				.querySelector(".body-wrapper")
				.addEventListener("click", clickAndCollectOutsideClickDetector);
		} else {
			document
				.querySelector(".body-wrapper")
				.removeEventListener("click", clickAndCollectOutsideClickDetector);
		}
		scrollPosition.reset();
	}

	/**
	 * Show or hide certain texts when Click and Collect is disabled.
	 * @param {number} [mode] - 0: Show web price only text.
	 */
	function reservationDisabledTexts(mode) {
		document
			.querySelectorAll(".cc-disabled-hide-text")
			.forEach(function (element) {
				element.style.display = "none";
			});

		if (mode === 0) {
			document
				.querySelectorAll(".cc-disabled-show-text")
				.forEach(function (element) {
					element.style.display = "";
				});
		}
	}

	/**
	 * Get traffic lights
	 */
	// function updateTrafficLights() {

	//   var trafficLightsElements = document.querySelectorAll('.product-availability .traffic-lights'),
	//       productTitleElements = document.querySelectorAll('.product-availability .product-details');

	//   trafficLightsElements.forEach(function (element) {
	//     element.innerHTML = '';
	//   });

	//   var prodTitle = '';

	//   var ean = templateData.product.ean;

	//   if (ean === '') {

	//     //Empty product title
	//     prodTitle = '';
	//     //Show info to choose size first
	//     trafficLightsElements.forEach(function (element) {
	//       element.innerHTML = '<div class="alert alert-info"><p>Valitsethan koon ensin</p></div>';
	//     });

	//   } else {

	//     if (shops !== '') {

	//       var title = '';

	//       if (templateData.product.name) {
	//         title += templateData.product.name + ' ';
	//       }

	//       if (templateData.product.color) {
	//         title += templateData.product.color+ ', ';
	//       }

	//       if (templateData.product.size) {
	//         title += 'koko ' + templateData.product.size;
	//       }

	//       //Update size & color to title
	//       prodTitle = title;

	//       //Add traffic lights info
	//       var dl = document.createElement('dl');

	//       for (var i = 0; i < templateData.stores.length; i++) {
	//         var astore = templateData.stores[i];
	//         var dt = document.createElement('dt');
	//         dt.setAttribute('title', astore.storeData.status);
	//         dt.innerHTML =
	//           '<span class="' + astore.balanceData.lights + '" title="' + astore.storeData.status + '"></span>' + astore.storeData.city + ', ' + astore.storeData.location;

	//         var dd = document.createElement('dd');
	//         dd.setAttribute('class', 'sr-only');
	//         dd.innerHTML = astore.storeData.status;
	//         dl.appendChild(dt);
	//         dl.appendChild(dd);

	//       }

	//       trafficLightsElements.forEach(function (element) {
	//         element.appendChild(dl.cloneNode(true));
	//       });

	//     } else {
	//       //Empty product title
	//       prodTitle = '';

	//       //Display error message
	//       trafficLightsElements.forEach(function (element) {
	//         element.innerHTML = '<div class="alert alert-info"><p>Saatavuustietoja ei voitu hakea.</p></div>';
	//       });
	//     }

	//     productTitleElements.forEach(function (element) {
	//       element.textContent = prodTitle;
	//     });

	//   }
	// }

	/**
	 * Update stores data.
	 */
	function updateStoresList() {
		templateData.stores = [];

		//You should fetch stores (includes balance data) before updating list

		for (var key of Object.keys(shops)) {
			var shop = shops[key];

			var status = shop.balanceText;
			var lights = "indicator available";

			var isAvailable = true;

			if (shop.balanceStatus === "someAvailable") {
				lights = "indicator limited";
				status = shop.balanceText;
			} else if (shop.balanceStatus === "notAvailable") {
				lights = "indicator sold-out";
				status = shop.balanceText;
			}

			if (
				shop.ccDisabled ||
				shop.balanceStatus === "notAvailable" ||
				clickAndCollectStatus === 0
			) {
				isAvailable = false;
			}

			templateData.stores.push({
				balanceData: { balance: shop.balance, lights: lights },
				storeData: {
					city: shop.shopDetails.city,
					location: shop.shopDetails.location,
					name: shop.name,
					link: shop.shopDetails.link,
					lat: shop.shopDetails.pos.lat,
					long: shop.shopDetails.pos.long,
					available: isAvailable,
					status: status,
					hidden: shop.hidden || shop.balanceStatus === "notAvailable"
				},
				id: shop.id,
				price: templateData.product.price,
				disableCc: shop.ccDisabled
			});

		}

		if (templateData.stores.length > 0) {
			//orderStoresByLocation();
			//updateTrafficLights();

			// console.log('update stores list', templateData.stores);
			templateData.hasStores = true;
		} else {
			templateData.hasStores = false;
		}
	}

	/**
	 * Update views
	 *
	 * @param {boolean} [updateShops=true] - Fetch shop and balance data.
	 */
	function updateView(updateShops) {
		var slelement = document.querySelector(".click-and-collect-stores-list");
		if (slelement) {
			scrollPosition.save();
			slelement.innerHTML = "";
		}

		if (updateShops === false) {
			updateStoresList();

			if (clickAndCollectStatus === 1 || clickAndCollectStatus === 0) {
				document.querySelector(
					"#click-and-collect-content"
				).innerHTML = Mustache.render(template, templateData);

				if (webPriceOnly) {
					reservationDisabledTexts(0);
				} else if (clickAndCollectStatus === 0) {
					reservationDisabledTexts(1);
				}

				scrollPosition.restore();
			}

			if (!shopsFetched) {
				showLoader("Kauppojen tietoja haetaan...");
			}
		} else {
			showLoader("Kauppojen tietoja haetaan...");
			$.ajax({
				type: "POST",
				method: "POST",
				cache: false,
				data: { ean: templateData.product.ean },
				url: "/stage-ajax/clickAndCollectBalances/"
			})
				.done(function (result) {
					shops = result;
					updateStoresList();

					if (clickAndCollectStatus === 1 || clickAndCollectStatus === 0) {
						document.querySelector(
							"#click-and-collect-content"
						).innerHTML = Mustache.render(template, templateData);

						if (webPriceOnly) {
							reservationDisabledTexts(0);
						} else if (clickAndCollectStatus === 0) {
							reservationDisabledTexts(1);
						}

						scrollPosition.restore();
					}
					// console.log('Balance check success', templateData.stores);
					shopsFetched = true;
				})
				.fail(function () {
					// console.log('Balance check error');
				})
				.always(function () {
					// console.log('Balance check complete');
					hideLoader();
				});
		}
	}

	/**
	 * Trigger event for element.
	 *
	 * @param {Element} element - Element.
	 * @param {string} type - Event type.
	 */
	function triggerEvent(element, type) {
		var evt = document.createEvent("Event");
		evt.initEvent(type, true, true);
		element.dispatchEvent(evt);
	}

	/**
	 * Fetch new token for the form and auto submit it.
	 *
	 * @param {Element} form - Form element.
	 */
	function updateFormToken(form) {
		var token = form.querySelector("input[name$=\"token\"]");

		$.ajax({
			url: "/stage-ajax/getToken",
			method: "GET",
			cache: false,
			dataType: "text"
		}).done(function (response) {
			token.value = response;

			if (form) {
				triggerEvent(form, "submit");
			}
		});
	}

	/**
	 * Format price
	 *
	 * @param {Number|String} price - Price.
	 * @param {Boolean} [appendEuro] - Add euro sign after the price.
	 *
	 * @return {String} - Formated price.
	 */
	function formatPrice(price, appendEuro) {
		appendEuro = typeof appendEuro !== "undefined" ? appendEuro : true; //default to this
		var formattedPrice = "";

		try {
			formattedPrice =
				parseFloat(price)
					.toFixed(2)
					.replace(".", ",")
					.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ") + (appendEuro ? " €" : "");
		} catch (e) {
			formattedPrice = price + (appendEuro ? " €" : "");
		}

		return formattedPrice;
	}

}
